import { EventViewData } from 'components/eventView/pages/eventData';

export const NamsskoganEvent: EventViewData = {
    eventId: 'namsskogan',
    mapId: '32235ad6-c714-42de-af32-5ff1f7b28b98',
    guideId: '179cd3fd-b60a-4940-bed6-bd26a3aab5c9'
};
